import createClient from 'openapi-fetch'
import { env } from '../env.ts'
import { fetch } from './helpers.ts'
import type { components, paths } from './notification-manager.types.ts'

export const notificationManager = createClient<paths>({
	baseUrl: env.API_AURORAL,
	fetch,
})

type Schema = components['schemas']
export type Webhook = Schema['Webhook']
export type WebhookSecret = Schema['WebhookSecret']
export type WebhookHeartbeatState = Schema['WebhookHeartbeatState']
export type WebhookInvocation = Schema['WebhookInvocation']
export type CreateWebhook = Schema['CreateWebhookDto']
export type CreateWebhookSecret = Schema['CreateWebhookSecretDto']
export type UpdateWebhook = Schema['UpdateWebhookDto']
export type UpdateWebhookSecret = Schema['UpdateWebhookSecretDto']
export type WebhookStatus = Webhook['status']

const keys = <T extends object>(value: T): (keyof T)[] => Object.keys(value) as unknown as (keyof T)[]
export const webhookStatusOptions: WebhookStatus[] = keys({ Enabled: true, Disabled: true } satisfies Record<WebhookStatus, true>)
